import { useState } from 'react';
import { XCircleIcon } from '@heroicons/react/20/solid';

export default function Error401() {

  return (
    <>
      <div className="h-screen w-full flex flex-col justify-center item-center text-center">
        <XCircleIcon className='h-10 text-red-700' />
        <h3 className="mt-2 text-sm font-semibold text-gray-900">Access Denied</h3>
        <p className="mt-1 text-sm text-gray-500">You do not have permission in this project</p>
      </div>
    </>
  )
}
